import React, { useState, useEffect, useCallback, ChangeEvent } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import PortraitIcon from '@material-ui/icons/Portrait';
import { IStaffNameProps } from './types';
import style from './style.module.css';
import BCComponentWrapper from 'design-v2/common/BCComponentWrapper/BCComponentWrapper';

const NS = 'StaffNamePanel';

export default function StaffNamePanel(props: IStaffNameProps) {
  const { name, handleChange } = props;
  const [staffName, setStaffName] = useState('');

  useEffect(() => {
    setStaffName(name);
  }, [name]);

  const handleChangeStaffName = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setStaffName(e.target.value);
    handleChange(e.target.value);
  }, []);

  return (
    <BCComponentWrapper title={'Staff name'} containerTestId={'staff-panel-test-id'} showWarning={props.showWarning} >
      <TextField
        value={staffName}
        onChange={handleChangeStaffName}
        placeholder="Enter staff name"
        fullWidth
        inputProps={{
          'data-testid': 'staff-name-input',
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment className={style.inputAdornmentWrapper} position="start">
              <PortraitIcon className={style.iconColor} />
            </InputAdornment>
          ),
          className: style.noBorder,
        }}
      />
    </BCComponentWrapper>
  );
}
